import { Box, Button, HStack, Image, Text } from '@chakra-ui/react'
import { Header } from '@hivemq/ui-library'
import { useOktaAuth } from '@okta/okta-react'
import { CircleUserIcon, LogOutIcon } from 'lucide-react'
import hivemqBeeNeg from '~/assets/hivemq-bee-neg.svg'
import { useAuth } from '~/contexts/AuthContext'

export function UserMenu() {
  const { user, logout } = useAuth()
  const { oktaAuth } = useOktaAuth()

  const handleLogout = async () => {
    await logout() // useAuth().logout(): backend + removeItem('auth_token') + state
    await oktaAuth.signOut() // terminates the Okta SSO session (redirects)
  }

  return (
    <Header.Menu overlayId="user_menu">
      {/*
        Header.MenuButton (ui-library) hardcodes the icon to `color: white`,
        which assumed the old black header. On the new TopBar that icon can be
        invisible, so we force it to the theme's primary content colour via a
        higher-specificity descendant override (a plain `color` prop on the
        wrapper can't win against the library's own class since it isn't
        inherited past an explicit color on the svg itself).
      */}
      <Box
        color="content.primary"
        css={{ '& svg': { color: 'var(--chakra-colors-content-primary)' } }}
      >
        <Header.MenuButton aria-label="Account" icon={CircleUserIcon} />
      </Box>
      <Header.MenuContent>
        <Header.MenuContentDetails textAlign="center">
          <Image src={hivemqBeeNeg} display="inline-block" height="60px" mb={2} alt="HiveMQ Logo" />
          <Text fontSize="1.1rem" fontWeight={600}>
            {user?.displayName || user?.email}
          </Text>
          <Text fontSize="sm" color="gray.500">
            {user?.email}
          </Text>
          {user?.role && (
            <Text fontSize="sm" color="blue.500" mt={1}>
              Role: {user.role}
            </Text>
          )}
        </Header.MenuContentDetails>

        <Header.MenuContentItem
          ariaLabel="Sign out"
          _hover={{ background: 'destructive.400' }}
          _focusVisible={{ background: 'destructive.400' }}
        >
          <HStack w="100%" justifyContent="space-between" asChild>
            <Button variant="plain" fontSize="md" color="white" onClick={handleLogout}>
              <span>Sign out</span>
              <LogOutIcon size={16} />
            </Button>
          </HStack>
        </Header.MenuContentItem>
      </Header.MenuContent>
    </Header.Menu>
  )
}
